import router from '../../helpers/router';
import { storecMobielService } from '../../services';

// initial state
const state = {
    list: [],
    status: [],
};

// getters
const getters = {};

// actions
const actions = {
    listUsers ({ dispatch, commit }, data) {
        return storecMobielService
            .listUsers(data)
            .then((nodes) => {
                commit('setList', nodes);

                return nodes;
            })
            .catch((error) => {
                commit('setList', []);
                dispatch('alert/error', { error }, { root: true });

                return error;
            });
    },

    listLocations ({ dispatch, commit }, id) {
        return storecMobielService
            .listLocations(id)
            .then((nodes) => {
                commit('setList', nodes);

                return nodes;
            })
            .catch((error) => {
                commit('setList', []);
                dispatch('alert/error', { error }, { root: true });

                return error;
            });
    },

    checkEmail ({ dispatch, commit }, email) {
        console.log('storecMobielStore: checkEmail', email);
        commit('checkRequest');

        return storecMobielService
            .checkEmail(email)
            .then((result) => {
                commit('checkSuccess');

                if (result.GebruikerMobielID > 0)
                {
                    return result;
                }

                return false;
            }).catch((error) => {
                commit('checkFailure');
                dispatch('alert/error', { error }, { root: true });

                return false;
            });
    },

    createUser ({ dispatch, commit }, { data }) {
        console.log('storecMobielStore: createUser');
        commit('addRequest');

        return storecMobielService
            .createUser(data)
            .then(() => {
                commit('addSuccess');
                dispatch('alert/success', { message: 'Gebruiker is toegevoegd' }, { root: true }).then(() => {
                    router.push('/admin/storec-mobiel');
                });
            })
            .catch((error) => {
                commit('addFailure');
                dispatch('alert/error', { error }, { root: true });

                return error;
            });
    },

    updateUser ({ dispatch, commit }, { id, data }) {
        console.log('storecMobielStore: updateUser');
        commit('updateRequest');

        return storecMobielService
            .updateUser(id, data)
            .then(() => {
                commit('updateSuccess');
                dispatch('alert/success', { message: 'Gebruiker is toegevoegd' }, { root: true }).then(() => {
                    router.push('/admin/storec-mobiel');
                });
            })
            .catch((error) => {
                commit('updateFailure');
                dispatch('alert/error', { error }, { root: true });

                return error;
            });
    },

    updateLocation ({ dispatch, commit }, { id, data }) {
        console.log('storecMobielStore: updateLocation');
        commit('updateRequest');

        return storecMobielService
            .updateLocation(id, data)
            .then(() => {
                commit('updateSuccess');
                dispatch('alert/success', { message: 'Vestiging is gewijzigd' }, { root: true }).then(() => {
                    router.push('/admin/storec-mobiel/locations');
                });
            })
            .catch((error) => {
                commit('updateFailure');
                dispatch('alert/error', { error }, { root: true });

                return error;
            });
    },

    deleteUser ({ dispatch, commit }, { id, data }) {
        console.log('storecMobielStore: deleteUser');
        commit('deleteRequest');

        return storecMobielService
            .deleteUser(id, data)
            .then(() => {
                commit('deleteSuccess');
                dispatch('alert/success', { message: 'Gebruiker is verwijderd' }, { root: true }).then(() => {
                    router.push('/admin/storec-mobiel');
                });
            })
            .catch((error) => {
                commit('deleteFailure');
                dispatch('alert/error', { error }, { root: true });

                return error;
            });
    },
};

// mutations
const mutations = {
    setList (state, nodes) {
        state.list = nodes;
    },

    // check
    checkRequest (state) {
        state.status = { checking: true };
    },
    checkSuccess (state) {
        state.status = { checked: true };
    },
    checkFailure (state) {
        state.status = {};
    },

    // add
    addRequest (state) {
        state.status = { adding: true };
    },
    addSuccess (state) {
        state.status = { added: true };
    },
    addFailure (state) {
        state.status = {};
    },

    // update
    updateRequest (state) {
        state.status = { updating: true };
    },
    updateSuccess (state) {
        state.status = { updated: true };
    },
    updateFailure (state) {
        state.status = {};
    },

    // update
    deleteRequest (state) {
        state.status = { deleting: true };
    },
    deleteSuccess (state) {
        state.status = { deleted: true };
    },
    deleteFailure (state) {
        state.status = {};
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
